// import { useEffect, useState } from "react";
// import { supabase } from "../lib/supabaseClient.ts";
// import MySlider from "./MySlider.js";

// function MainSlider() {

//   const settings = {
//     autoplay: false,
//     autoplaySpeed: 10000,
//     dots: false,
//     fade: true,
//     arrows: true,
//     swipe: true,
//     touchMove: true,
//     // nextArrow: <CustomNextArrow />,
//     // prevArrow: <CustomPrevArrow />,
//     responsive: [
//       { breakpoint: 767, settings: { dots: false, arrows: false } }
//     ]
//   };
// const [slides, setSlides] = useState([]);

// useEffect(() => {
//   const fetchSlides = async () => {
//     const { data, error } = await supabase
//       .from('main_slider')
//       .select('*')
//       .order('order_index', { ascending: true });

//     if (error) {
//       console.error("Erreur Supabase :", error);
//     } else {
//       setSlides(data);
//     }
//   };

//   fetchSlides();
// }, []);


//   return (
// <section className="slider-area" style={{ overflowX: 'hidden', width: '100%', position: 'relative' }}>
//   <div className="text-center d-md-none mt-2">
//     {/* <small className="text-muted">Swipe ⟷</small> */}
//   </div>
//   <MySlider slides={slides} settings={settings} />

// </section>

//   );
// }

// export default MainSlider;
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";
import MySlider from "./MySlider";

function MainSlider() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const { data, error } = await supabase
          .from("main_slider")
          .select("*")
          .eq("is_active", true) // Only fetch active slides
          .order("order_index", { ascending: true });

        if (error) {
          console.error("Supabase error:", error);
        } else {
          setSlides(data || []);
        }
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSlides();
  }, []);

  if (loading) {
    return (
      <section className="slider-area" style={{ height: "60vh", background: "#f0f0f0" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <p>Loading slider...</p>
        </div>
      </section>
    );
  }

  return (
    <section
      className="slider-area"
      style={{
        overflowX: "hidden",
        width: "100%",
        position: "relative",
      }}
    >
      <MySlider slides={slides} />
    </section>
  );
}

export default MainSlider;